// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2JlhA","log":"ModalInventoryLogs_log__FO96F","date":"ModalInventoryLogs_date__3aQIN","userName":"ModalInventoryLogs_userName__ZDLny"};